<template>
  <article
    class="in-product position-relative product-card"
    :style="lowOpacity ? 'opacity: 0.7' : ''"
  >
    <!-- <span v-if="checkFreeShipMent()" id="shipment_free">
      ارسال رایگان
    </span> -->
    <router-link
      :to="
        product
          ? {
              name: 'product.detail',
              params: { id: product.id, slug: product.slug },
            }
          : ''
      "
      class="text-center"
    >
      <div class="recommended-products-img position-relative text-center">
        <img
          loading="lazy"
          width="400"
          height="400"
          decoding="async"
          v-if="product && mainImage"
          class="w-100 h-auto"
          :src="getImage(mainImage)"
          :alt="product.title"
          :title="product.title"
        />
        <img
          width="400"
          height="400"
          loading="lazy"
          v-else
          class="skeleton-image"
          :alt="product ? product.title : ''"
          :title="product ? product.title : ''"
        />
        <template v-if="product && product.major_final_price">
          <DiscountTag
            class="discount-peice"
            :final-price="product.major_final_price"
          />
        </template>
      </div>

      <div v-if="product" class="text-center position-relative">
        <h3 class="text-color-444 weight-bold mb-0 mt-2 mt-sm-3 prodctTitle">
          {{ product.title }}
        </h3>
        <div
          class="d-flex justify-content-center pb-2 align-items-center product-prices-gap"
          v-if="product.status == 'available'"
        >
          <div class="d-flex align-items-center" style="gap: 4px;">
            <span
              v-if="discountAmount != 0"
              class="line-through text-muted fontsize-small"
              >{{ (mainPrice + discountAmount) | price }}</span
            >
            <span class="text-color-444 fontsize-medium mainPrice"
              >{{ mainPrice | price }}
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="#a55e3e"
                  d="M3.52231 9.85151C3.70646 11.2265 3.81695 13.9888 3.7924 15.5724C3.76785 16.751 3.91517 17.107 4.86047 17.107H4.92186L5.02007 18.0278L4.92186 18.9363H4.86047C3.00669 18.9363 2.31919 17.8559 2.31919 15.8057C2.30692 13.9642 2.2087 11.6194 2 10.183L3.52231 9.85151Z"
                ></path>
                <path
                  fill="#a55e3e"
                  d="M4.80273 18.9363L4.83956 17.107H5.06054C5.64983 17.107 6.20228 16.7633 6.63196 15.953C7.35629 14.6026 8.04378 13.7187 8.97681 13.6696C11.3462 13.5468 12.0705 17.7086 10.2168 18.8258C9.51699 19.2555 8.36298 18.8381 7.04937 18.0155C6.53375 18.6416 5.83398 18.9363 5.03599 18.9363H4.80273ZM7.83508 16.5669C8.78039 17.1439 9.54154 17.4508 9.76252 17.2912C10.3027 16.9474 9.95895 15.3146 9.0382 15.3146C8.719 15.3146 8.32615 15.6216 7.83508 16.5669Z"
                ></path>
                <path
                  fill="#a55e3e"
                  d="M12.1629 20.9374C14.3727 20.4586 15.6004 19.8693 16.0055 18.9485C14.4709 18.924 13.145 18.7521 12.654 17.7086C11.9419 16.1863 13.0837 13.5713 14.7656 13.5713C16.0915 13.5713 17.0859 15.2164 17.3314 17.107H17.847L17.9452 18.0278L17.847 18.9363H17.2946C16.8894 20.7655 15.2321 22.0423 12.7276 22.5211L12.1629 20.9374ZM13.7834 16.6774C14.029 17.0088 14.9374 17.0948 16.0301 17.107C15.8214 16.1372 15.3426 15.3269 14.741 15.2164C14.0167 15.0691 13.4765 16.2477 13.7834 16.6774Z"
                ></path>
                <path
                  fill="#a55e3e"
                  d="M17.6909 18.9363V17.107H18.2802C19.9621 17.107 20.5022 16.8124 20.5022 16.2599C20.49 15.8425 19.9375 14.4184 19.827 14.1975L21.1284 13.4854C21.3616 13.9888 21.865 15.376 21.865 16.3459C21.8527 18.0032 20.7601 18.9363 18.5502 18.9363H17.6909ZM17.8136 11.9877C18.1451 11.6439 18.5011 11.3002 18.8326 10.9564C19.1764 11.3002 19.5201 11.6439 19.8516 11.9877C19.5201 12.3314 19.1764 12.6629 18.8326 13.0066C18.5011 12.6629 18.1451 12.3314 17.8136 11.9877ZM19.9621 11.9877C20.2935 11.6439 20.6496 11.3002 20.981 10.9564C21.3248 11.3002 21.6685 11.6439 22 11.9877C21.6685 12.3314 21.3248 12.6629 20.981 13.0066C20.6496 12.6629 20.2935 12.3314 19.9621 11.9877Z"
                ></path>
                <path
                  fill="#a55e3e"
                  d="M5.90307 3.41851C5.57159 4.16739 5.26468 4.92855 5.24012 5.73881C5.19102 7.18746 6.11177 7.8504 7.72002 7.8504C9.51242 7.8504 10.5437 6.80688 10.5437 5.73881C10.5437 5.05131 9.9421 3.3203 9.75795 2.7924L11.0716 2.1049C11.5749 3.45534 11.845 4.69529 11.845 5.73881C11.845 7.86268 10.2122 9.66735 7.72002 9.66735C5.30151 9.66735 3.70553 8.14504 3.87741 5.73881C3.93879 4.69529 4.40531 3.54128 4.7245 2.87834L5.90307 3.41851ZM6.82382 2.12946C7.21667 1.74888 7.58497 1.38058 7.96555 1L9.09501 2.12946C8.71443 2.51003 8.34613 2.89061 7.96555 3.25891C7.58497 2.89061 7.21667 2.51003 6.82382 2.12946Z"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div v-else class="hide-by-hover ">
          <span
            v-if="product.status == 'out_of_stock'"
            class="text-color-themeRed fontsize14"
          >
            ناموجود
          </span>
          <span
            v-if="product.status == 'soon'"
            class="text-color-themeRed fontsize14"
          >
            به زودی
          </span>
        </div>
      </div>
      <div v-else class="mt-3 px-4 px-sm-5">
        <b-skeleton />
        <b-skeleton class="mt-2" />
      </div>
    </router-link>
  </article>
</template>

<script>
import { BFormRating, BSkeleton } from "bootstrap-vue";
import { getImages, sortVarieties, getImage } from "@/libraries/functions";
import DiscountTag from "./DiscountTag";
import Tick from "@/parts/Front/components/shared/Tick";
export default {
  name: "Product",
  components: { Tick, DiscountTag, BFormRating, BSkeleton },
  props: {
    product: Object,
    lowOpacity: Boolean,
    comparable: {
      default: false,
      type: Boolean,
    },
    them: {
      default: "",
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    getImage,
    getProductInFlashes() {
      let products = [];
      this.homeData.flashes.forEach((flash) => {
        products.push(...flash.products);
      });
      return products;
    },
    checkFreeShipMent() {
      if (this.$route.path == "/") {
        if (
          this.product &&
          this.product.pivot &&
          this.product.pivot.shipment_free == 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.homeData != null) {
          if (this.homeData.flashes.length) {
            let res = false;

            let flashesProduct = this.getProductInFlashes();
            console.log(flashesProduct);
            if (flashesProduct.length) {
              flashesProduct.forEach((fp) => {
                console.log(fp.id);
                console.log(this.product.id);
                if (fp.id == this.product.id) {
                  res = true;
                  console.log("inja");
                }
              });
            }
            return res;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
  },
  computed: {
    mainPrice() {
      return this.product ? this.product.price : null;
    },
    discountAmount() {
      return this.product ? this.product.major_discount_amount : null;
    },
    mainImage() {
      return this.product ? this.product.major_image : null;
    },
    isComparing() {
      return Boolean(
        this.$store.getters["front/getCompares"].find(
          (i) => i.id == this.product.id
        )
      );
    },
    homeData() {
      return this.$store.getters["front/getHomeData"];
    },
  },
};
</script>

<style scoped>
.product-card {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--color-da);
}

.discount-peice {
  position: absolute;
  top: 2%;
  left: 2%;
}

.mainPrice {
  color: var(--newTheme-color);
}

.in-product {
  background-color: white;
}

@media screen and (max-width: 768px) {
  .recommended-content-item article:hover .hide-by-hover {
    opacity: 1 !important;
  }
}

.skeleton-image {
  width: 308px;
  display: inline-block;
  background-image: radial-gradient(
    rgb(244, 244, 244),
    rgb(244, 244, 244),
    rgb(244, 244, 244)
  );
}

.compare-btn {
  z-index: 2;
  position: absolute;
  left: 3px;
  top: 10px;
  background: white;
  border-radius: 4px;
  padding: 1px 9px;
  border: 1px solid #7570b3;
  font-size: 13px;
  transition: 200ms all;
  cursor: pointer;
}

.compare-btn.compareBtnWithFreeShipping {
  top: 30px;
}

.compare-btn:not([selected]) {
  opacity: 0;
}

.compare-btn[selected] {
  opacity: 1 !important;
}

.in-product:hover .compare-btn {
  transition: 200ms all;
  opacity: 0.6;
  pointer-events: unset;
}

.compare-btn input {
  transform: translateY(3px);
}

.compare-btn input:hover {
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .compare-btn:not([selected]) {
    opacity: 0.7;
  }
}

.compare-btn-mobile {
  width: 35px;
  height: 35px;
  transition: all 0.3s;
  background: #555555;
  border-radius: 50%;
  padding: 7px;
  margin-right: 8px;
}

.compare-btn-mobile[selected] {
  background: var(--color-themeBlue);
}

.product-prices-gap {
  gap: 10px;
}

@media screen and (max-width: 575px) {
  .in-product {
    border-bottom: 1px solid #00000024;
    padding-block: 10px;
  }

  .in-product:not(:nth-child(2n)) {
    border-left: 1px solid #00000024;
  }
}
</style>
<style>
.product-rate .b-rating.disabled,
.b-rating:disabled {
  background-color: unset !important;
}

.product-rate .form-control {
  padding: 0;
  border: unset !important;
  width: 130px;
  direction: ltr;
}

.product-rate .b-rating .b-rating-star {
  padding: 0;
}

.show-by-hover.recommended-title-hover {
  position: absolute;
  bottom: 0;
}

.prodctTitle {
  max-width: 250px;
  height: 26px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 800;
  font-size: 16px;
  margin: auto;
  padding-inline: 6px;
}

@media (max-width: 1250px) {
  .prodctTitle {
    width: 200px;
  }
}

@media (max-width: 500px) {
  .prodctTitle {
    font-size: 14px;
    width: 170px;
    padding-inline: 8px;
  }
}

.py-25 {
  padding: 14px 0;
}

span#shipment_free {
  position: absolute;
  left: 0;
  background: green;
  z-index: 10000;
  color: white;
  padding: 5px 10px;
  top: 0;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  font-size: 13px;
}
</style>
